import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    EditButton,
    DeleteButton,
    ShowButton,
    Confirm,
    Button
} from 'react-admin';
import { Chip } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import DripCampaignFilter from './DripCampaignFilter';
import CardActions from '../common/CardActions';
import {useTranslation} from 'react-i18next';


const TriggerTypeField = ({ record }) => {
    const {t} = useTranslation();
    
    const getChipColor = (triggerType) => {
        switch (triggerType) {
            case 'contact_created':
                return 'primary';
            case 'manual_enrollment':
                return 'secondary';
            default:
                return 'default';
        }
    };

    const getTriggerLabel = (triggerType) => {
        switch (triggerType) {
            case 'contact_created':
                return t('drip.trigger.contact_created');
            case 'manual_enrollment':
                return t('drip.trigger.manual_enrollment');
            default:
                return triggerType;
        }
    };

    return (
        <Chip 
            label={getTriggerLabel(record.triggerType)}
            color={getChipColor(record.triggerType)}
            size="small"
        />
    );
};

const StatusField = ({ record }) => {
    return (
        <Chip 
            label={record.isActive ? 'Active' : 'Not Active'}
            color={record.isActive ? 'primary' : 'default'}
            size="small"
        />
    );
};

const GroupField = ({ record }) => {
    return (
        <span>{record.targetGroupName || '-'}</span>
    );
};

const ConfirmDeleteButton = ({ record, resource, basePath }) => {
    const {t} = useTranslation();
    const [open, setOpen] = React.useState(false);
    
    const handleConfirm = () => {
        setOpen(false);
        // Trigger the hidden DeleteButton
        setTimeout(() => {
            const hiddenDeleteBtn = document.querySelector(`#hidden-delete-${record.id}`);
            if (hiddenDeleteBtn) {
                hiddenDeleteBtn.click();
            }
        }, 100);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <>
            <Button onClick={() => setOpen(true)} label="ra.action.delete">
                <DeleteIcon />
            </Button>
            <DeleteButton 
                id={`hidden-delete-${record.id}`}
                record={record}
                resource={resource}
                basePath={basePath}
                style={{ display: 'none' }}
                undoable={false}
            />
            <Confirm
                isOpen={open}
                title={t('drip.delete.confirm_title')}
                content={t('drip.delete.confirm_message', { name: record.name })}
                onConfirm={handleConfirm}
                onClose={handleCancel}
            />
        </>
    );
};



const DripCampaignList = (props) => {
    const {t} = useTranslation();

    return (
        <List
            {...props}
            filters={<DripCampaignFilter />}
            actions={<CardActions />}
            sort={{ field: 'name.value', order: 'ASC' }}
            perPage={25}
        >
            <Datagrid>
                <TextField source="name" label={t('drip.name')} sortBy={'name.value'} />
                <GroupField source="targetGroupName" label={t('drip.target_group')} />
                <NumberField
                    source="delayInHours"
                    label={t('drip.delay_in_hours')}
                    options={{ minimumFractionDigits: 0 }}
                />
                <TriggerTypeField source="triggerType" label={t('drip.trigger_type')} />
                <StatusField source="isActive" label={t('drip.status')} />
                <NumberField
                    source="totalEnrollments"
                    label={t('drip.total')}
                    options={{ minimumFractionDigits: 0 }}
                />
                <NumberField
                    source="sentEnrollments"
                    label={t('drip.sent')}
                    options={{ minimumFractionDigits: 0 }}
                />
                <NumberField
                    source="queuedEnrollments"
                    label={t('drip.queued')}
                    options={{ minimumFractionDigits: 0 }}
                />
                <ShowButton />
                <EditButton />
                <ConfirmDeleteButton />
            </Datagrid>
        </List>
    );
};

export default DripCampaignList;